import { ApiDashboardReportPostRequest, Configuration, DashboardApi, DettaglioInfoDashboardDto, LottoApi, LottoSmallDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';

export const setDataInizio = createAction<Date, 'setDataInizio'>('setDataInizio');
export const setDataFine = createAction<Date, 'setDataFine'>('setDataFine');
export const setCampagna = createAction<number | undefined, 'setCampagna'>('setCampagna');

export const getElencoDatiDashboard = createAsyncThunk<DettaglioInfoDashboardDto | undefined, number | undefined, ThunkApiConfig>(
  'dashboard/getElencoDatiDashboard', async (tipoDashboard, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return (await import('../../../../../mock/dashboard.json')).default;
      } else {
        const form = getState().homeDashboard.form;
        const requestParameters: ApiDashboardReportPostRequest = {
          ricercaDashboardDto: {
            "dataInizio": new Date(form.dataInizio.getFullYear(), form.dataInizio.getMonth(), form.dataInizio.getDate(), 0, 0, 0),
            "dataFine": new Date(form.dataFine.getFullYear(), form.dataFine.getMonth(), form.dataFine.getDate(), 23, 59, 59),
            "tipoDashboard": tipoDashboard,
            "idLotto": form.idLotto
          }
        };
        return await new DashboardApi(getConfiguration(Configuration, extra, getState)).apiDashboardReportPost(requestParameters);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const getElencoLotti = createAsyncThunk<Array<LottoSmallDto> | undefined, undefined, ThunkApiConfig>(
  'dashboard/getElencoLotti', async (_, { dispatch, extra, getState }) => {
    try {
      return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoLottiGet();
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);
